import API from './api.js'

export default {
    async login(username, password) {
        try {
            let response = await API.HTTPS.post('/users/login', '{ "username": "' + username + '", "password": "' + password + '" }', { headers: { "Content-Type": "application/json" } })

            localStorage.setItem('userId', response.data.userId)
            localStorage.setItem('token', response.data.token)
            localStorage.setItem('refreshToken', response.data.refreshToken)

            API.HTTPS.defaults.headers.common["Authorization"] = `Bearer ${response.data.token}`

            return { code: 0, data: response.data }
        }
        catch (e) {
            localStorage.removeItem('userId')
            localStorage.removeItem('token')
            localStorage.removeItem('refreshToken')

            if (e.response != null && e.response.status === 400)
                return { code: 1, data: null }
            else
                return { code: 2, data: null }
        }
    },

    async getFolders(userId) {
        try {
            let response = await API.HTTPS.get('/users/' + userId + '/folders')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    async getFlatFolders(userId) {
        let response = await this.getFolders(userId)
        if (response.code === 0) {
            const result = []
            const queue = []
            for (let i = 0; i < response.data.length; i++) {
                if (response.data[i].id < 0) continue
                queue.push(response.data[i])
                while (queue.length > 0) {
                    let child = queue.shift()
                    result.push(child)
                    if (child.parentId == null) {
                        child.children?.forEach(c => queue.push(c))
                    }
                }
            }
            response.data = result
        }
        return response
    },

    async getUsers(page, pagesize) {
        try {
            let response = await API.HTTPS.get('/users?page=' + page + '&pagesize=' + pagesize)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getUser(userId) {
        try {
            let response = await API.HTTPS.get('/users/' + userId)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async postUser(user) {
        try {
            let response = await API.HTTPS.post('/users', user)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async patchUser(user) {
        try {
            let response = await API.HTTPS.patch('/users/' + user.id, user)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async putUser(user) {
        try {
            let response = await API.HTTPS.put('/users/' + user.id, user)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async deleteUser(id) {
        try {
            let response = await API.HTTPS.delete('/users/' + id)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async resetPassword(user) {
        try {
            let response = await API.HTTPS.post('/users/resetPassword', user)

            return { code: 0, data: response.data }
        }
        catch (e) {
            if (e.status == 409)
                return { code: 1, data: null }
            else
                return { code: 2, data: null }
        }
    }
}